import { render, staticRenderFns } from "./TicketEventItem.vue?vue&type=template&id=a5fd7892&"
import script from "./TicketEventItem.vue?vue&type=script&lang=ts&"
export * from "./TicketEventItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5fd7892')) {
      api.createRecord('a5fd7892', component.options)
    } else {
      api.reload('a5fd7892', component.options)
    }
    module.hot.accept("./TicketEventItem.vue?vue&type=template&id=a5fd7892&", function () {
      api.rerender('a5fd7892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/tickets/ticket-event-times/TicketEventItem.vue"
export default component.exports